// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatDIV {
    overflow-y: auto;
}

.userDIV {
    border-right: 1px solid lightgray;
}

.userList {
    overflow-y: auto;
    border-bottom: 1px solid lightgray;
}

.jiraicon {
    width: 24px;
    height: 24px;
}

.chatMessage {
    background-color: lightgray;
    border-radius: 5px;
    margin: 0px 30px 5px 0px;
    align-self: flex-start;
    padding: 5px;
}

    .chatMessage.ownMessage {
        background-color: darkolivegreen;
        margin: 0px 0px 5px 30px;
        align-self: flex-end;
    }

    .chatMessage .messageHeader {
        font-size: 11px;
        margin-bottom: 2px;
    }

        .chatMessage .messageHeader .sender {
            font-weight: bold;
            margin-right: 5px;
        }

.userMenuImage {
    height: 24px;
    width: 24px;
    border-radius: 50%;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/common/collaboration/user.overview.control.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,YAAY;AAChB;;IAEI;QACI,gCAAgC;QAChC,wBAAwB;QACxB,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,iBAAiB;QACrB;;AAER;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".chatDIV {\n    overflow-y: auto;\n}\n\n.userDIV {\n    border-right: 1px solid lightgray;\n}\n\n.userList {\n    overflow-y: auto;\n    border-bottom: 1px solid lightgray;\n}\n\n.jiraicon {\n    width: 24px;\n    height: 24px;\n}\n\n.chatMessage {\n    background-color: lightgray;\n    border-radius: 5px;\n    margin: 0px 30px 5px 0px;\n    align-self: flex-start;\n    padding: 5px;\n}\n\n    .chatMessage.ownMessage {\n        background-color: darkolivegreen;\n        margin: 0px 0px 5px 30px;\n        align-self: flex-end;\n    }\n\n    .chatMessage .messageHeader {\n        font-size: 11px;\n        margin-bottom: 2px;\n    }\n\n        .chatMessage .messageHeader .sender {\n            font-weight: bold;\n            margin-right: 5px;\n        }\n\n.userMenuImage {\n    height: 24px;\n    width: 24px;\n    border-radius: 50%;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
